import { useRouter } from "next/router";
import { useEffect, useState } from "react";

const Countdown = ({ date }) => {
  const [timeLeft, setTimeLeft] = useState({});
  const { locale } = useRouter();

  useEffect(() => {
    let interval;
    const updateCountdown = () => {
      const now = new Date().getTime();
      let dateTo = new Date(date);
      const target = dateTo.getTime();
      let difference = target - now;

      if (difference <= 0) {
        clearInterval(interval);
        setTimeLeft({});
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      // Update `dateTo` if `hours` is 0 and `minutes` is less than 20

      setTimeLeft({ days, hours, minutes, seconds });
    };

    updateCountdown(); // Run initially to avoid delay
    interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [date, locale]);

  return (
    <div className="relative flex items-center justify-center gap-1 px-6 pt-2 scale-[85%] border-4 border-white rounded-full md:scale-100 md:pt-4 md:px-10 ">
      <div
        className={`flex items-center ${
          locale === "ar" ? "flex-row-reverse" : "flex-row"
        } justify-center text-3xl md:text-5xl text-white`}
        style={{ columnGap: "16px" }}
      >
        <div className="flex flex-col items-center justify-center gap-1 pb-1 font-bold rounded-md">
          <span>
            {timeLeft.days < 10 ? "0".concat(timeLeft.days) : timeLeft.days}
          </span>
          <span className="text-sm">{locale === "ar" ? "يوم" : "Day"}</span>
        </div>
        <div className="-mt-10 font-bold">:</div>
        <div className="flex flex-col items-center justify-center gap-1 pb-1 font-bold rounded-md">
          <span>
            {timeLeft.hours < 10 ? "0".concat(timeLeft.hours) : timeLeft.hours}
          </span>
          <span className="text-sm">{locale === "ar" ? "ساعة" : "Hour"}</span>
        </div>
        <div className="-mt-10 font-bold">:</div>
        <div className="flex flex-col items-center justify-center gap-1 pb-1 font-bold rounded-md">
          <span>
            {timeLeft.minutes < 10
              ? "0".concat(timeLeft.minutes)
              : timeLeft.minutes}
          </span>

          <span className="text-sm">
            {locale === "ar" ? "دقيقة" : "Minutes"}
          </span>
        </div>
        <div className="-mt-10 font-bold">:</div>
        <div className="flex flex-col items-center justify-center gap-1 pb-1 font-bold rounded-md">
          <span>
            {timeLeft.seconds < 10
              ? "0".concat(timeLeft.seconds)
              : timeLeft.seconds}
          </span>
          <span className="text-sm">
            {locale === "ar" ? "ثانية" : "Second"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
